import isEqual from 'lodash/isEqual';
import { useEffect } from 'react';

import { usePrevious } from '@sravni/react-utils';
import type { IPublicUser } from '@sravni/types/lib/auth';

export function useUserChangeHandler(user: IPublicUser | undefined, cb: (user: IPublicUser) => void) {
  const prevUser = usePrevious(user);

  useEffect(() => {
    if (isEqual(prevUser, user)) return;

    if (user) {
      cb(user);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, prevUser]);
}
